import React, {createContext, ReactNode, useContext, ReactElement} from 'react'

type IconsContextType = {
    [category: string]: {
        [name: string]: ReactElement
    };
};

const IconsContext = createContext<IconsContextType>({});

const useIcons = () => useContext(IconsContext);

const IconsProvider = ({
    value,
    children
}: {
    value: IconsContextType;
    children: ReactNode;
}) => {
    return <IconsContext.Provider value={value}>
        {children}
    </IconsContext.Provider>
};

export type {IconsContextType}

export {IconsProvider, useIcons};